const mode = 'Domain';  // Change to Live or Develop or Public or Test

const config = {
    DomainTest: {
        IP: 'https://prepaidtest.cial.aero/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
    Domain: {
        IP: 'https://prepaid.cial.aero/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
    Lives: {
        IP: 'https://115.241.227.167:6005/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
    Live: {
        IP: 'http://115.241.227.167:4112/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
    Develop: {
        IP: 'http://192.168.1.138:3001/',
        merchantId: "T1055795",
        consumerId: "c964634",
        key: "1651646990KATWWL"
    },
    Test: {
        IP: 'https://192.168.1.138:3002/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
    Public: {
        IP: 'https://103.156.209.203:3004/',
        merchantId: "L1064541",
        consumerId: "c964634",
        key: "1654349203QTNPSX"
    },
};

export const IP = config[mode].IP;
export const merchantId = config[mode].merchantId;
export const consumerId = config[mode].consumerId;
export const key = config[mode].key;

export const REDIRECT_URL = `${IP}web/response`;
export const API_BASE_URL = `${IP}web/`;
export const LOG_TRANSACTION = `${IP}web/log-transaction`;
export const GENERATE_HASH = `${IP}web/generate-hash`;